import { copilotTypes, usersTypes } from '../../types';

const showOnboarding = window.localStorage.getItem('copilot.onboarding') === null;

const defaultState = {
  isOnboardingEnabled: showOnboarding
};

const map = {
  [`${copilotTypes.TOGGLE_ONBOARDING_STATE}`]: (state, action) => ({
    ...state,
    isOnboardingEnabled: action.payload
  }),
  [usersTypes.SWITCH_WORKSPACE]: () => defaultState
};

export default (state = defaultState, action) =>
  (map[action.type] && map[action.type](state, action)) || state;
